import { FeatureModuleAuth } from '@core/types';
import gql from 'graphql-tag';

/************************************************************************
 *  Entitlements
 ************************************************************************/

export interface IAuthUserEntitlementsResponse {
    getUserAuth: FeatureModuleAuth[];
}

export const GET_USER_ENTITLEMENTS = gql`
    query {
        getUserAuth {
            id
            name
            nations {
                id
                name
                products {
                    id
                    hasSchedulerAccess
                    name
                    reports
                }
            }
        }
    }
`;
